/* eslint-disable react/forbid-prop-types */
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { TextareaInput } from 'components/FormControl';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useReplyAdjustmentComment } from 'utils/hooks/adjustmentComments';
import { toast } from 'layout';
import { TOAST } from 'constant';
import { mapError } from 'utils/func';
import { yupResolver } from '@hookform/resolvers/yup';
import { replyAdjustmentCommentSchema } from 'features/Project/validation';

function ReplyAdjustmentCommentModal({
  visible,
  onClose,
  adjustmentCommentId,
  onSubmit,
  isSubmitting,
  isRevise,
}) {
  const { t } = useTranslation();
  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(replyAdjustmentCommentSchema),
  });
  const { mutateAsync, isLoading } = useReplyAdjustmentComment();

  const onSubmitReply = async (data) => {
    try {
      const res = await mutateAsync({
        id: adjustmentCommentId,
        data: {
          reply: data.reply,
        },
      });
      if (res.status.toString().startsWith('2')) {
        onSubmit();
      }
    } catch (error) {
      toast(TOAST.ERROR, mapError(t, error));
    }
  };

  const formatHeader = () => (
    <p className="text-blue-500">
      {t(`projectAdjustment.replyModal.${isRevise ? 'reviseTitle' : 'title'}`)}
    </p>
  );

  return (
    <Dialog
      header={formatHeader}
      visible={visible}
      position="center"
      style={{ width: '600px' }}
      onHide={onClose}
      draggable={false}
    >
      <form onSubmit={handleSubmit(onSubmitReply)} className="p-fluid">
        <TextareaInput
          name="reply"
          label={t('projectAdjustment.replyModal.reply')}
          control={control}
          errors={errors}
          row={6}
          isRequired
        />

        <div className="flex justify-content-end gap-2 mt-4">
          <Button
            type="button"
            label={t('employee.cancel')}
            className="w-7rem"
            severity="danger"
            onClick={onClose}
            autoFocus
          />
          <Button
            label={t('employee.ok')}
            className="w-7rem"
            severity="info"
            type="submit"
            disabled={isLoading || isSubmitting}
          />
        </div>
      </form>
    </Dialog>
  );
}

ReplyAdjustmentCommentModal.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  adjustmentCommentId: PropTypes.string.isRequired,
  isSubmitting: PropTypes.bool,
  isRevise: PropTypes.bool,
};

ReplyAdjustmentCommentModal.defaultProps = {
  visible: false,
  onClose: () => {},
  onSubmit: () => {},
  isSubmitting: false,
  isRevise: false,
};

export default React.memo(ReplyAdjustmentCommentModal);
